module.exports = __webpack_public_path__ + "static/media/sign-up-img-4.80b69f2e.png";